import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { affiliateQuotesKeys } from './keys';

const getAffiliateQuotes = async (affiliateFirmId: string) => {
  const response = await fetcher(`affiliate-firms/${affiliateFirmId}/quotes`, {
    method: 'GET',
  });

  return response.json();
};

const useAffiliateQuotes = (affiliateFirmId: string) => {
  return useQuery({
    queryFn: () => getAffiliateQuotes(affiliateFirmId),
    queryKey: [affiliateQuotesKeys.FETCH_AFFILIATE_QUOTES, affiliateFirmId],
    staleTime: 0,
    refetchOnMount: true,
  });
};

export { useAffiliateQuotes };
